import * as React from 'react';

const ShareFillChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="share-fill-chunky_svg__eds-icon-share-fill-chunky"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <path d="M19 20.5c-1.3 0-2.5-1.1-2.5-2.4v-.3l-9.3-3.5-.2.2c-.5.6-1.2 1-2 1-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5c.7 0 1.4.3 1.8.8l.2.3 9.5-4v-.4V7c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5c-.7 0-1.3-.3-1.8-.8l-.2-.2-9.5 4v.7l.3.2 9 3.4.2-.3c.5-.6 1.2-1 2-1 1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z" />
            <path d="M19 5c1.1 0 2 .9 2 2s-.9 2-2 2c-.5 0-1.1-.2-1.4-.6l-.5-.5-.1-.8V7c0-1.1.9-2 2-2M5 11c.6 0 1.1.2 1.5.7l.5.5.6-.3-.6.3v1.4l-.5.6c-.3.5-.9.8-1.5.8-1.1 0-2-.9-2-2s.9-2 2-2m14 5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2v-.7l.4-.6c.4-.4 1-.7 1.6-.7m0-12c-1.7 0-3 1.3-3 3v.2L7.2 11c-.5-.6-1.3-1-2.2-1-1.7 0-3 1.3-3 3s1.3 3 3 3c1 0 1.8-.5 2.4-1.2l8.6 3.3c0 1.6 1.4 2.9 3 2.9 1.7 0 3-1.3 3-3s-1.3-3-3-3c-1 0-1.8.5-2.4 1.2L8 12.9v-.1l8.9-3.7c.5.5 1.2.9 2.1.9 1.7 0 3-1.3 3-3s-1.3-3-3-3z" />
        </g>
    </svg>
);

ShareFillChunkySvg.displayName = 'ShareFillChunkySvg';
export default ShareFillChunkySvg;
